import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import { FormattedMessage, injectIntl } from 'react-intl'
import fieldId from 'constants/layout/fieldId'
import styles from './radio.styl'

@injectIntl
class Radio extends Component {
  static propTypes = {
    value: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    secondary: PropTypes.bool,
    horizontal: PropTypes.bool,
    disabledGroup: PropTypes.bool,
    intlKey: PropTypes.string,
    intlKeySub: PropTypes.string,
    // onChange: PropTypes.func,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string,
    validate: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(PropTypes.func)
    ]),
    readOnly: PropTypes.bool,
    tertiary: PropTypes.bool
  }

  static defaultProps = {
    validate: () => {}
  }

  handleChange = field => {
    field.input.onChange(this.props.value)
  }

  renderField = field => {
    const {
      label,
      subLabel,
      disabled,
      disabledGroup,
      secondary,
      value,
      name,
      intlKey,
      intlKeySub,
      tertiary,
      readOnly,
    } = this.props
    const secondaryClass = secondary ? styles.secondary : ''
    const disabledClass = disabled || disabledGroup ? styles.disabled : ''
    const tertiaryClass = tertiary ? styles.tertiary : ''
    const readOnlyClass = readOnly ? styles.readOnly : ''

    return (
      <div
        className={`${styles.controls} ${disabledClass} ${secondaryClass} ${tertiaryClass} ${readOnlyClass}`}
      >
        <input
          className={`form-control ${styles.formControl}`}
          type="radio"
          {...field.input}
          value={this.props.value}
          id={`id-${name}-${value}`}
          onChange={() => this.handleChange(field)}
          checked={this.props.value === field.input.value}
          disabled={disabled || disabledGroup}
        />
        <label
          htmlFor={`id-${name}-${value}`}
          className={`control-label ${styles.controlLabel}`}
        >
          {intlKey
            ? <FormattedMessage id={intlKey} defaultMessage={label} />
            : label}
          {subLabel &&
            <p className={styles.subLabel}>
              {intlKeySub
                ? <FormattedMessage id={intlKeySub} defaultMessage={subLabel} />
                : subLabel}
            </p>}
        </label>
      </div>
    )
  }

  render() {
    const { horizontal, name } = this.props
    const horizontalClass = horizontal ? ' horizontal' : ''

    return (
      <div
        className={`${styles.formGroup} ${horizontalClass}`}
        id={`${fieldId}.${name}`}
      >
        <Field
          name={name}
          {...this.props}
          component={this.renderField}
          validate={this.props.validate}
        />
      </div>
    )
  }
}

export default Radio
